<template>
  <v-card v-if="frame && info" class="iFrameDialog" @click="close">
    <iframe :class="{ 'mobile': $vuetify.breakpoint.smAndDown }"
      :src="frame"
      :width="$vuetify.breakpoint.smAndDown ? '' : 675"
    >
    </iframe>
  </v-card>
</template>

<script>
import { get } from 'lodash'
import { loadStripe } from '@stripe/stripe-js';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    frame: null,
    info: null
  }),
  computed: {
    ...mapGetters([ 'isTest', 'getStoreID' ])
  },

  methods: {
    close() {
      window.top.postMessage({
        message: '3DS-authentication-complete',
        payload: 'error'
      });

      this.frame = null
    }
  },

  mounted() {
    let _this = this

    // 3DS Event listener
    async function on3DSComplete(payment_intent_client_secret) {
      const handleError = (message=null, showError=true) => {
        if (showError)
          _this.$bus.$emit('showAlert', message||'Error with authentication', 'error', 10000)
      }

      // Pull the information out and always reset ids
      const { stripeAccountId } = _this.info
      _this.info = null

      // Skip the actual even handler if the user closed the dialog
      if (payment_intent_client_secret == 'error') {
        handleError('Bad client secret', false)
        return
      }

      // Check the PaymentIntent
      const stripeKey = _this.isTest ? 'pk_test_yTuFHGcSGCBm65aYYT5Vt0Ee' : 'pk_live_ppArwjpEtPJBVq0xPuwlC3ro'
      let stripe = await loadStripe(stripeKey, { stripeAccount: stripeAccountId });

      stripe.retrievePaymentIntent(payment_intent_client_secret).then(function(result) {
        if (result.error) {
          // PaymentIntent client secret was invalid
          handleError('PaymentIntent client secret was invalid')
          console.log('Includes error: ', result);
        } else {
          const { status } = result.paymentIntent

          if (status === 'succeeded' || status === 'requires_capture') {
            // Show your customer that the payment has succeeded
            _this.$bus.$emit('showAlert', _this.$vuetify.lang.t('$vuetify.paymentDetails.accepted'), 'primary')

            _this.$router.replace({
              name: 'Confirmation',
              params: { storeId: _this.getStoreID }
            })
          } else {
            // Authentication failed, prompt the customer to enter another payment method
            console.error('failed: ', result);
            let message = get(result, 'paymentIntent.last_payment_error.message') ||
                            get(result, 'paymentIntent.status') ||
                            'Failed to retrieve payment intent'
                            
            handleError(`Payment failed: ${message}`)
          }
        }
    })}

    window.top.addEventListener('message', function(ev) {
      if (ev.data.message === '3DS-authentication-complete') {
        _this.frame = null

        on3DSComplete(ev.data.payload);
      }
    }, false);

    this.$bus.$on('setFrame', (frame, info) => {
      this.frame = frame
      this.info = info
    })
  }
}
</script>

<style>
  .iFrameDialog {
    position: fixed;
    top: -25px;
    left: 0;

    height: calc(100vh + 25px);
    width: 100vw;

    z-index: 10;

    background-color: rgba(0,0,0,.87) !important;
    background: rgba(0,0,0,.87) !important;
  }

  .iFrameDialog iframe {
    position: fixed;
    top: 5vh;
    left: calc(50vw - 350px);

    height: 90vh;
    max-height: 750px !important;
    /* width: 982px; */
    max-width: 683px;
    width: 100vw;

    margin: auto;

    over-flow: hidden !important;
  }
  .iFrameDialog iframe.mobile {
    height: 100vh !important;
    max-height: 100vh !important;
    width: 100vw;

    top: 0px;
    left: 0px;
  }

  .iFrameDialog iframe {
    height: calc(100% - 48px);
    /* height: 100% */
  }

  .v-dialog--fullscreen iframe {
    width: 100vw
  }
</style>
